import name2value from './name2value.js'
import value2name from './value2name.js'

export default {
  name2value: name2value,
  value2name: value2name
}

